export const ManageRoutes = {
	Local: 'http://localhost:1800',
	LocalLive: 'http://localhost:1810',
	Cypress: 'http://localhost:1820',
	Test: 'https://manage.stage.agilox.net',
	Beta: 'https://manage.beta.agilox.net',
	Live: 'https://manage.agilox.net',
	Stage: 'https://manage.stage.agilox.net',
} as const;
